export const GET_ANIME = 'GET_ANIME';
export const GET_EPISODE = 'GET_EPISODE';
export const GET_ANIMES = 'GET_ANIMES';
